'use client';

import PropTypes from 'prop-types';
import { CartProvider } from '../context/CartContext';
import { CustomerAuthProvider } from '../context/CustomerAuthContext';
import { WishlistProvider } from '../context/WishlistContext';

export default function AppProviders({ children }) {
  return (
    <CustomerAuthProvider>
      <CartProvider>
        <WishlistProvider>{children}</WishlistProvider>
      </CartProvider>
    </CustomerAuthProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};
